import { render, staticRenderFns } from "./SectionView.vue?vue&type=template&id=4a873d4a&scoped=true"
import script from "./SectionView.vue?vue&type=script&lang=ts"
export * from "./SectionView.vue?vue&type=script&lang=ts"
import style0 from "./SectionView.vue?vue&type=style&index=0&id=4a873d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a873d4a",
  null
  
)

export default component.exports